import { ENDPOINTS } from "src/api/endpoints";

export interface NewsletterParams {
  email: string;
}

export const subscribeToNewsletter = async (
  { email }: NewsletterParams,
  headers: { Authorization: string }
): Promise<any> => {
  const endpoint = ENDPOINTS.NEWSLETTER;
  const payload = { email_address: email };

  try {
    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        ...headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to subscribe to newsletter");
    }
  } catch (error) {
    console.error("Newsletter subscription error:", error);
    throw error;
  }
};
